import Inventory2Icon from "@mui/icons-material/Inventory2";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import SpeedIcon from "@mui/icons-material/Speed";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { useAppTrialAccess } from "../useAppTrialAccess";
import ActivarSuscripcionBanner from "../ActivarSuscripcionBanner";
import '../premiumLanding.css';

export default function InventarioLandingPage() {
  const { canRequestTrial, mustRenew, startTrial } =
    useAppTrialAccess("inventario");

  const features = [
    {
      icon: <Inventory2Icon />,
      titulo: "Kardex automatizado",
      desc: "Control de entradas, salidas y saldos en tiempo real. Método promedio ponderado.",
    },
    {
      icon: <PointOfSaleIcon />,
      titulo: "Registro de ventas",
      desc: "Registra ventas rápidamente y actualiza tu inventario al instante.",
    },
    {
      icon: <TrendingUpIcon />,
      titulo: "Ganancias reales",
      desc: "Visualiza ingresos, costos y ganancias netas por día, semana o mes.",
    },
    {
      icon: <AccountBalanceWalletIcon />,
      titulo: "Arqueo de caja",
      desc: "Cierra tu día con arqueo: efectivo, QR, diferencias y control total.",
    },
    {
      icon: <ReceiptLongIcon />,
      titulo: "Control de gastos",
      desc: "Registra gastos operativos por categoría y descuéntalos de tus ganancias.",
    },
    {
      icon: <SwapHorizIcon />,
      titulo: "Traspasos QR ↔ Efectivo",
      desc: "Controla movimientos entre cajas sin perder el rastro de tu dinero.",
    },
    {
      icon: <CalendarMonthIcon />,
      titulo: "General del día",
      desc: "Resumen diario completo: ventas, compras, gastos, ajustes y balance.",
    },
    {
      icon: <SpeedIcon />,
      titulo: "Rápido y sin internet",
      desc: "Funciona offline. Tus datos se sincronizan cuando vuelvas a conectarte.",
    },
  ];

  return (
    <div className="pl">
      {/* HERO */}
      <section className="pl-hero">
        <div className="pl-wrap">
          <span className="pl-eyebrow">Inventario, ventas y caja</span>
          <h1>Inventario y Ventas</h1>
          <p className="pl-hero-sub">
            Controla tu stock, registra ventas y compras, y conoce tus ganancias reales cada
            día. <strong>El sistema más completo para negocios pequeños en LATAM.</strong>
          </p>
          <div className="pl-cta-row">
            {canRequestTrial && (
              <button type="button" className="pl-btn pl-btn-accent" onClick={startTrial}>
                Probar ahora
              </button>
            )}
          </div>
          <p className="pl-hero-note">Desde USD 8 / mes · Sin contratos · Cancela cuando quieras</p>
        </div>
      </section>

      {/* Para quién */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>¿Para quién es este sistema?</h2>
            <p>Para cualquier negocio que necesite saber qué tiene, cuánto vendió y cuánto ganó — sin complicaciones.</p>
          </div>
          <div className="pl-usecase-grid">
            {[
              "Tiendas de barrio",
              "Ferreterías",
              "Distribuidoras",
              "Farmacias",
              "Papelerías y librerías",
              "Abarrotes y minimarkets",
              "Negocios de comida",
              "Talleres y repuestos",
              "Cualquier comercio minorista",
            ].map((item) => (
              <div key={item} className="pl-usecase">{item}</div>
            ))}
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="pl-section pl-section-muted">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>Todo lo que necesitas para tu negocio</h2>
            <p>Inventario, ventas, gastos, arqueo de caja y ganancias en un solo lugar.</p>
          </div>
          <div className="pl-feature-grid">
            {features.map((f) => (
              <div key={f.titulo} className="pl-feature-card">
                <div className="pl-feature-icon">{f.icon}</div>
                <h3>{f.titulo}</h3>
                <p>{f.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Cómo funciona */}
      <section className="pl-section">
        <div className="pl-wrap">
          <div className="pl-section-head">
            <h2>Así de fácil</h2>
            <p>En 3 pasos ya estás usando el sistema.</p>
          </div>
          <div className="pl-steps-grid">
            {[
              {
                paso: "1",
                titulo: "Carga tus productos",
                desc: "Agrega tu inventario inicial con nombres, cantidades y precios.",
              },
              {
                paso: "2",
                titulo: "Registra movimientos",
                desc: "Compras, ventas y gastos del día. Todo queda registrado automáticamente.",
              },
              {
                paso: "3",
                titulo: "Revisa tus ganancias",
                desc: "Al final del día, haz arqueo de caja y conoce tu ganancia real.",
              },
            ].map((step) => (
              <div key={step.paso} className="pl-step">
                <div className="pl-step-num">{step.paso}</div>
                <h3>{step.titulo}</h3>
                <p>{step.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="pl-section">
        <div className="pl-wrap">
          {canRequestTrial ? (
            <div className="pl-cta-block">
              <h2>Empieza hoy</h2>
              <p>Prueba gratis por 30 días. Sin tarjeta. Sin compromiso.</p>
              <div className="pl-cta-row">
                <button type="button" className="pl-btn pl-btn-primary" onClick={startTrial}>
                  Activar prueba gratis
                </button>
              </div>
            </div>
          ) : (
            <ActivarSuscripcionBanner appKey="inventario" appName="Inventario y Ventas" />
          )}
        </div>
      </section>
    </div>
  );
}
